import {
  COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED,
  FLIGHTS_DAYVIEW_ITINERARIES_RENDERED,
  ITINERARIES_BATCH,
} from '@web-platform/shared-universal-constants/src/redux/actions/render';

import type { FlightsDayViewItinerariesRenderedAction } from '@web-platform/shared-universal-types/src/redux/acorn/actions/actions-acorn-types';
import type { CombinedResultsFlightsItinerariesRenderedAction } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';

type RenderAction =
  FlightsDayViewItinerariesRenderedAction | CombinedResultsFlightsItinerariesRenderedAction;

export default function (state: boolean = false, action: RenderAction): boolean {
  switch (action.type) {
    case FLIGHTS_DAYVIEW_ITINERARIES_RENDERED:
    case COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED:
      return action.payload.batch === ITINERARIES_BATCH.LAST;

    default: {
      return state;
    }
  }
}
export const get = (state: boolean): boolean => state;
